const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/

const EDGE_COUNTRY_HEADER_NAMES = [
	'cf-ipcountry',
	'x-vercel-ip-country',
	'cloudfront-viewer-country',
] as const

export enum COUNTRY_GROUP {
	Default = 'default',
	Us = 'us',
}

const GROUP_BY_COUNTRY_CODE: Record<string, COUNTRY_GROUP> = {
	US: COUNTRY_GROUP.Us,
}

type TCountryHeaders = { get(name: string): string | null }

const normalizeCountryCode = (countryCode?: string | null): string | null => {
	if (!countryCode) return null

	const normalizedCountryCode = countryCode.trim().toUpperCase()

	return COUNTRY_CODE_PATTERN.test(normalizedCountryCode)
		? normalizedCountryCode
		: null
}

export const getCountryFromHeaders = (
	headers?: TCountryHeaders | null,
): string | null => {
	if (!headers) return null

	for (const headerName of EDGE_COUNTRY_HEADER_NAMES) {
		const normalizedCountryCode = normalizeCountryCode(
			headers.get(headerName),
		)

		if (normalizedCountryCode) return normalizedCountryCode
	}

	return null
}

export const getCountryGroup = (countryCode?: string | null): COUNTRY_GROUP =>
	GROUP_BY_COUNTRY_CODE[normalizeCountryCode(countryCode) ?? ''] ??
	COUNTRY_GROUP.Default
